import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    lng: "hu",
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          menu_1: 'Bank selection',
          menu_2: 'Privacy Statement',
          menu_3: 'Bank consent',
          main_title: 'Financial Health Assessment Platform',
          main_subtitle: 'Credit rating in seconds!',
          main_subtitle2: 'Free service without any commitment',
          hello: 'Hello',
          next: 'Next',
          restart: 'Try again',
          step: 'Step',
          back: 'Back',
          check_your_data: 'Please check your data then click next if correct',
          bank_select: 'Select your bank',
          bank_select_desc: 'We\'ll create your Financial Report using data from your bank. ',
          bank_select_desc2: '1. <b>Select your bank. </b>For the most accurate report, select the bank where you hold your main account.<br/><br/>2. <b>Log in securely. </b>You\'ll be redirected to your bank\'s secure login page.<br/><br/>3. <b>Authorize Access. </b>Follow your bank\'s instructions to authorize the transfer of your account information via a secure API connection.',
          bank_select_desc3: 'After accepting the Privacy Statement, you will be redirected to your bank\'s website.',
          bank_select_desc4: 'Provide consent in your bank’s secure environment to allow us to create your Financial Report. You can log in as usual, using your regular bank credentials. Of course, you do not have to give your password to anyone other than your bank during the process.',
          bank_select_desc5: 'Please note that in some countries, CYGNUS partners with other AISP companies (Open Banking aggregators like GoCardless), so you may see their names during the bank\'s consent process.',
          bank_data_input_desc: 'Click on \"Next\" and we redirect you to your bank\'s website. This will open a new window. Please follow the instructions there. DO NOT close and DO NOT refresh this window',
          bank_waiting: 'Waiting for results',
          bank_waiting_desc: 'Please follow the instructions on your bank\'s website. DO NOT refresh this window.',
          bank_error: 'Error',
          bank_error_desc: 'Unfortunately there was an error',
          bank_success: 'Success',
          bank_success_desc: 'All good',
          close_window: 'Close',
          you_selected: 'Selected bank',
          full_name: 'Full legal name',
          legal_name: 'Legal name',
          email: 'E-mail address',
          phone: 'Phone number',
          dob: 'Date of birth',
          address: 'Address',
          country_code_hu: 'Hungary',
          client_type: 'Client type',
          client_type_personal: 'Personal account',
          client_type_business: 'Business account',
          all_rights: 'All rights reserved ⓒ 2025 - Cygnus AISP UAB',
          terms_of_service: 'Terms of service',
          impressum: 'Impressum',
          cookie_policy: 'Cookie policy',
          not_available: 'Currently not available',
          bank_error_title: 'There was an error',
          bank_error: 'We\'re sorry, but there was an error during the process. Please contact our support.',
          bank_success_title: 'Success!',
          bank_success: 'You have no other steps to complete.',
          bank_success_next: 'Continue to the website of the provider',
          european_banking_authority: 'European Banking Authority',
          aisp_licence: 'AISP Registered Lincence',
          chosen_bank: 'Chosen bank',
          cant_be_empty: 'Can\'t be empty',
          must_be_long: 'This field must be at least 8 characters long',
          please_accept_terms: 'Please accept the terms to continue',
          please_enter_data: 'Please enter the following data to start the process',
          bank_account_number: 'Bank account number',
          bank_login_id: 'Bank login ID',
          bank_login_id_input: 'Direkt ID',
          bank_login_id_input_hr: 'OIB number',
          bank_login_id_input_hr_otp: 'mToken number',
          bank_login_id_desc: 'To authorize your consent the Direkt ID you use to log in to your bank will be needed.',
          bank_login_id_desc_hr: 'To authorize your consent your personal OIB number will be needed for the bank',
          bank_login_id_desc_hr_otp: 'To authorize your consent your personal mToken number will be needed for the bank',
          bank_account_number_part_1: 'Part 1',
          do_credit_check: 'Create report',
          accept_terms_text: '<0>I consent to CYGNUS, as both data controller and data processor, accessing my bank account data solely for the purpose of providing payment services (a solvency report). I have read, fully understood, and agree to the <3>Privacy Statement</3>.</0>',
          working: 'We are currently working on it...',
          please_wait: 'Please don\'t close this window while we generate your report. ',
          invalid_account_number: 'This account number is invalid. Please check again.',
          account_number_required: 'Account number is required for this bank',
          account_number_not_numeric: 'Account number must only contain numbers',
          account_number_length: 'The account number must be 16 or 24 characters long',
          account_number_format_cz: 'The account number must be in proper format',
          account_number_format_hr: 'The account number must be in proper format (17 digits)',
          bank_login_id_required: 'Your bank login ID is required for this bank',
          bank_login_id_format_hu: 'The bank login ID must be in proper format (8 digits)',
          bank_login_id_format_hr: 'The OIB number must be in proper format (11 digits)',
          bank_login_id_format_hr_otp: 'The mToken number must be in proper format (10 digits)',
          window_open_text: 'If a new window did not appear please click here to continue:',
          continue: 'Continue',
          bank_not_on_the_list: 'My bank is not on the list',
          refuse_consent: 'I don\'t want to give consent',
          need_bank_account: 'You will need your bank account number in IBAN format to proceed. If you know your account number but don\'t know your IBAN number',
          click_here: 'click here',
          validate_iban_title: 'IBAN validation',
          validate_iban: 'Validate IBAN',
          validate_iban_desc: 'Write down or paste your account number in domestic format. If you paste a text the text can contain numbers and dashes.',
          iban_account_number: 'IBAN account number:',
          close: 'Close'
        }
      },
      hu: {
        translation: {
          menu_1: 'Bank kiválasztása',
          menu_2: 'Adatvédelmi Nyilatkozat',
          menu_3: 'Banki jóváhagyás',
          main_title: 'Hitelminősítő platform',
          main_subtitle: 'Azonnali minősítés másodperceken belül!',
          main_subtitle2: 'Ingyenes  szolgáltatás, kötelezettségek nélkül',
          hello: 'Hello',
          next: 'Következő',
          restart: 'Próbálkozzunk újra',
          step: 'Lépés',
          back: 'Vissza',
          check_your_data: 'Please check your data then click next if correct',
          bank_select: 'Bankválasztás',
          bank_select_desc: 'A bankodtól megkapott adatokból rendszerünk létrehozza fizetőképességi megítélésedet.',
          bank_select_desc2: '1. <b>Válaszd ki bankodat. </b>Annak érdekében, hogy az elemzés valós képet mutasson, a fő számládat vezető bankot célszerű kiválasztanod.<br/><br/>2. <b>Belépés. </b>Bankod oldalán a megszokott azonosítóval és jelszóval kell belépned<br/><br/>3. <b>Engedély megadása. </b>Belépést követően a jóváhagyás megadásán kívül egyéb teendőd nincs.',
          bank_select_desc3: 'Az Adatvédelmi Nyilatkozat elfogadása után átirányítunk bankod weboldalára.',
          bank_select_desc4: 'Hozzájárulásodat bankod biztonságos környezetében kell megadnod ahhoz, hogy elkészíthessük a pénzügyi állapotfelmérésedet. Bankodhoz a szokásos azonosítóddal, a szokásos módon jelentkezhetsz be. A jelszavadat bankodon kívül természetesen senkinek nem kell megadnod a folyamat során.',
          bank_select_desc5: 'Felhívjuk figyelmedet, hogy egyes országokban a CYGNUS más cégekkel (Open Banking aggregátorokkal, mint például a GoCardless) működik együtt, így a bank hozzájárulási folyamata során ezen társaságok neveivel is találkozhatsz.',
          bank_data_input: 'Redirecting you',
          bank_data_input_desc: 'Click on \"Next\" and we redirect you to your bank\'s website. This will open a new window. Please follow the instructions there. DO NOT close and DO NOT refresh this window',
          bank_waiting: 'Waiting for results',
          bank_waiting_desc: 'Please follow the instructions on your bank\'s website. DO NOT refresh this window.',
          bank_error_desc: 'Unfortunately there was an error',
          bank_success_desc: 'All good',
          close_window: 'Close',
          you_selected: 'Selected bank',
          full_name: 'Full legal name',
          legal_name: 'Legal name',
          email: 'E-mail address',
          phone: 'Phone number',
          dob: 'Date of birth',
          address: 'Address',
          country_code_hu: 'Hungary',
          client_type: 'Client type',
          client_type_personal: 'Personal account',
          client_type_business: 'Business account',
          all_rights: 'All rights reserved ⓒ 2025 - Cygnus AISP UAB',
          terms_of_service: 'Terms of service',
          impressum: 'Impressum',
          cookie_policy: 'Cookie policy',
          not_available: 'Jelenleg nem elérhető',
          bank_error_title: 'Valami nem sikerült',
          bank_error: 'Sajnáljuk, de valamiért nem tudtuk átnézni a bankszámlád. Amennyiben többször tapasztalatod ezt a problémát, kérjük, vedd fel a kapcsolatot Ügyfélszolgálatunkkal!',
          bank_success_title: 'Szuper, köszönjük, minden rendben!',
          bank_success: 'Nincs további teendőd!',
          bank_success_next: 'Tovább a szolgáltató honlapjára',
          european_banking_authority: 'European Banking Authority',
          aisp_licence: 'AISP Registered Lincence',
          chosen_bank: 'Válaszott bank',
          cant_be_empty: 'Ez a mező kötelező',
          must_be_long: 'Eza mező 8 karakter hosszú',
          please_accept_terms: 'Kérlek fogadd el a szabályzatot',
          please_enter_data: 'Kérjük add meg az alábbi adatokat, hogy elindíthassuk az összekötést.',
          bank_account_number: 'Bankszámlaszám',
          bank_login_id: 'Felhasználói azonosító',
          bank_login_id_input: 'Direct ID',
          bank_login_id_input_hr: 'OIB szám',
          bank_login_id_desc: 'A bankszámla azonosításához meg kell majd adnod a Netbankodhoz használt Direkt ID-t is!',
          bank_login_id_desc_hr: 'A bankszámla azonosításához meg kell majd adnod az OIB számodat is!',
          bank_login_id_desc_hr_otp: 'A bankszámla azonosításához meg kell majd adnod az mToken számodat is!',
          bank_account_number_part_1: 'Első 8',
          bank_account_number_part_2: 'Második 8',
          bank_account_number_part_3: 'Harmadik 8',
          do_credit_check: 'Minősítés elvégzése',
          accept_terms_text: '<0>Kijelentem, hogy az <3>Adatkezelési Tájékoztatót</3> elolvastam, és hozzájárulok az adataim jelen tájékoztatóban írtak szerinti kezeléséhez.</0>',
          working: 'Dolgozunk...',
          please_wait: 'Kérjük várj amíg végzünk, és addig ne zárd be a böngészőablakot!',
          invalid_account_number: 'A számlaszám nem érvényes számlaszám, kérlek ellenőrizd még egyszer',
          account_number_required: 'A bankodnál kötelező a számlaszám megadása a folyamat indításához',
          account_number_not_numeric: 'A számlaszám csak számot tartalmazhat',
          account_number_length: 'A számlaszám 16 vagy 24 karakter hosszú kell hogy legyen',
          account_number_format_cz: 'A számlaszám nem megfelelő formátumú',
          account_number_format_hr: 'A számlaszám nem megfelelő formátumú (17 számjegy)',
          bank_login_id_required: 'A bankodnál a banki azonosítód megadása kötelező a folyamat indításához',
          bank_login_id_format_hu: 'A banki azonosító nem megfelelő formátumú (8 számjegy)',
          bank_login_id_format_hr: 'Az OIB azonosító nem megfelelő formátumú (11 számjegy)',
          bank_login_id_format_hr_otp: 'Az mToken azonosító nem megfelelő formátumú (10 számjegy)',
          window_open_text: 'Amennyiben nem nyílt meg egy új ablak kérlek kattints ide a folytatáshoz:',
          continue: 'Folytatás',
          bank_not_on_the_list: 'A bankom nincs a listán',
          refuse_consent: 'Nem szeretnék engedélyt adni',
          need_bank_account: 'Szükséged lesz az IBAN számlaszámodra a folytatáshoz. Ha tudod a számlaszámod, de nem tudod az IBAN számlaszámod formátumát',
          click_here: 'kattints ide',
          validate_iban_title: 'IBAN ellenőrzés',
          validate_iban: 'IBAN ellenőrzés',
          validate_iban_desc: 'Írd vagy másold be a számlaszámod belföldi formátumban, és megmutatjuk az IBAN számlaszámod. Ha bemásolod, a számlaszám tartalmazhat számokat és kötőjeleket is.',
          iban_account_number: 'IBAN számlaszámod:',
          close: 'Bezárás'
        }
      },
      cz: {
        translation: {
          menu_1: 'Výběr banky',
          menu_2: 'Prohlášení o ochraně osobních údajů',
          menu_3: 'Souhlas s bankou',
          main_title: 'Platforma úvěrového ratingu',
          main_subtitle: 'Rating během několika sekund!',
          main_subtitle2: 'Bezplatná služba bez závazků',
          hello: 'Vítejte!',
          next: 'Další',
          restart: 'Skuste znovu',
          step: 'Krok',
          back: 'Zpět',
          check_your_data: 'Zkontrolujte prosím svá data a pokud jsou správné, klikněte na Další',
          bank_select: 'Vyberte svou banku',
          bank_select_desc: 'Z údajů, které obdržíme od Vaší banky, náš systém vygeneruje report o vaší solventnosti. ',
          bank_select_desc2: '1. Vyberte si svou banku, do které budete přesměrováni. Aby zpráva odpovídala přesné situaci, doporučuje se vybrat banku, kde máte svůj hlavní účet.<br/><br/>2. Na webu Vaší banky se přihlaste jako obvykle, svým uživatelským jménem a heslem <br/><br/>3. Po přihlášení už stači jen váš souhlas.',
          bank_select_desc3: 'Po přijetí Prohlášení o ochraně osobních údajů budete přesměrováni na webové stránky své banky.',
          bank_select_desc4: 'Souhlas je třeba udělit v zabezpečeném prostředí vaší banky, abychom mohli připravit vaše finanční hodnocení. Do své banky se přihlásíte obvyklým způsobem pomocí běžného přihlašovacího údaje. Vaše heslo samozřejmě nikomu mimo vaši banku během procesu nesdělujete.',
          bank_select_desc5: 'Upozorňujeme, že v některých zemích spolupracuje CYGNUS s jinými společnostmi (agregátory otevřeného bankovnictví, jako je například GoCardless), takže během procesu udělování souhlasu se můžete setkat s názvy těchto společností.',
          bank_data_input: 'Přesměrování',
          bank_data_input_desc: 'Klikněte na \"Další\"a přesměrujeme vás na web vaší banky. Tím se otevře nové okno. Postupujte prosím podle pokynů v něm. Toto okno NEzavírejte a NEobnovujte.',
          bank_waiting: 'Čekání na výsledky',
          bank_waiting_desc: 'Postupujte podle pokynů na webu vaší banky. NEOBNOVUJTE toto okno prosím!.',
          bank_error: 'Vyskytla se chyba',
          bank_error_desc: 'Bohužel se vyskytla chyba',
          bank_success: 'Výborně!',
          bank_success_desc: 'Vše v pořádku',
          close_window: 'Zavřít',
          you_selected: ' Vybraná banka',
          full_name: 'Obchodní jméno',
          legal_name: 'Jméno',
          email: 'Váš e-mail',
          phone: 'Telefónní číslo',
          dob: 'Datum narození',
          address: 'Adresa',
          country_code_hu: 'Česká republika',
          client_type: 'Typ klienta',
          client_type_personal: 'Osobní účet',
          client_type_business: 'Podnikatelský účet',
          all_rights: 'All rights reserved ⓒ 2025 - Cygnus AISP UAB',
          terms_of_service: 'Podmínky služeb',
          impressum: 'Impressum',
          cookie_policy: 'Nastavení cookies',
          not_available: 'Momentálně není k dispozici',
          bank_error_title: 'Něco se nepovedlo',
          bank_error: 'Je nám líto, ale během operace došlo k chybě. Kontaktujte prosím naši podporu!', 
          bank_success_title: 'Děkujeme, vše je v pořádku!',
          bank_success: 'Výborně!',
          bank_success_next: 'Pokračovat na web poskytovatele služeb',
          european_banking_authority: ' European Banking Authority ',
          aisp_licence: 'AISP Registered Lincence',
          chosen_bank: 'Vybraná banka',
          cant_be_empty: 'Toto pole je povinné',
          must_be_long: 'Toto pole musí mít alespoň 8 znaků',
          please_accept_terms: 'Chcete-li pokračovat, přijměte prosím Zásady ochrany osobních údajů',
          please_enter_data: 'Pro zahájení procesu zadejte prosím následující údaje',
          bank_account_number: 'Čislo účtu',
          bank_login_id: 'Uživatelské jméno',
          bank_login_id_input: 'Klientské číslo',
          bank_login_id_input_hr: 'OIB number',
          bank_login_id_desc: 'K autorizaci vašeho souhlasu bude zapotřebí vaše klientské číslo, které budete používat k přihlášení do své banky!',
          bank_login_id_desc_hr: 'To authorize your consent your personal OIB number is needed for the bank',
          bank_login_id_desc_hr_otp: 'To authorize your consent your personal mToken number is needed for the bank',
          bank_account_number_part_1: 'První 8',
          bank_account_number_part_2: 'Druhý 8',
          bank_account_number_part_3: 'Třetí 8',
          do_credit_check: 'Generovat report',
          accept_terms_text: '<0> Prohlašuji, že jsem si přečetl/a <3>Zásady ochrany osobních údajů</3> a souhlasím se zpracováním mých údajů.</0>',
          working: 'Právě na tom pracujeme...',
          please_wait: 'Během generování reportu prosím nezavírejte toto okno. Tato operace trvá jen minutku!',
          invalid_account_number: 'Zadané číslo účtu je nesprávné. Zkontrolujte prosím znovu.',
          account_number_required: 'Pro zahájení procesu je nutné zadat číslo účtu ve vaší bance',
          account_number_not_numeric: 'Číslo účtu může obsahovat pouze číslo',
          account_number_length: 'Číslo účtu musí mít 16 nebo 24 znaků',
          account_number_format_cz: 'Číslo účtu musí být ve správném formátu',
          account_number_format_hr: 'Číslo účtu musí být ve správném formátu (10 číslic)',
          bank_login_id_required: 'K autorizaci vašeho souhlasu je zapotřebí vaše klientské číslo, které používáte k přihlášení do své banky.',
          bank_login_id_format_hu: 'vaše klientské číslo být ve správném formátu (8 číslic)',
          bank_login_id_format_hr: 'vaše klientské číslo být ve správném formátu (11 číslic)',
          bank_login_id_format_hr_otp: 'vaše klientské číslo být ve správném formátu (10 číslic)',
          window_open_text: 'Pokud se nezobrazilo nové okno, pokračujte kliknutím sem:',
          continue: 'Pokračovat',
          bank_not_on_the_list: 'Moje banka není na seznamu',
          refuse_consent: 'Nechci poskytnout souhlas',
          need_bank_account: 'K pokračování budeš potřebovat své číslo účtu ve formátu IBAN. Pokud znáš své číslo účtu, ale neznáš formát IBAN',
          click_here: 'klikni sem',
          validate_iban_title: 'Ověření IBAN',
          validate_iban: 'Ověření IBAN',
          validate_iban_desc: 'Zadejte nebo vložte své číslo účtu v domácím formátu a my vám zobrazíme váš IBAN. Pokud číslo účtu vložíte, může obsahovat číslice a pomlčky.',
          iban_account_number: 'Vaše číslo účtu IBAN:',
          close: 'Zavřít'
        }
      },
      hr: {
        translation: {
          "menu_1": "Odabir banke",
          "menu_2": "Izjava o privatnosti",
          "menu_3": "Suglasnost banke",
          "main_title": "Platforma za kreditni rejting",
          "main_subtitle": "Kreditni rejting u sekundi!",
          "main_subtitle2": "Besplatna usluga bez ikakvih obveza",
          "hello": "Pozdrav",
          "next": "Dalje",
          "restart": "Pokušaj ponovno",
          "step": "Korak",
          "back": "Natrag",
          "check_your_data": "Molimo provjerite svoje podatke, a zatim kliknite dalje ako su točni",
          "bank_select": "Odaberite svoju banku",
          "bank_select_desc": "Izradit ćemo vaš Izvještaj o solventnosti na temelju informacija iz vaše banke.",
          "bank_select_desc2": "1. Odaberite svoju banku. Kako bi izvješće točno odražavalo vašu situaciju, preporučuje se odabrati banku u kojoj imate svoj glavni račun.<br/><br/>2. Prijavite se izravno u svoju banku<br/><br/>3. Vaša banka će vas voditi kroz proces autorizacije CYGNUS.",
          "bank_select_desc3": 'Nakon prihvaćanja Izjave o privatnosti bit ćete preusmjereni na web stranicu svoje banke.',
          "bank_select_desc4": 'Suglasnost morate dati u sigurnom okruženju svoje banke kako bismo mogli pripremiti vašu procjenu financijskog stanja. U svoju banku prijavljujete se na uobičajen način pomoću standardnih vjerodajnica. Lozinku, naravno, ne trebate dijeliti ni s kim izvan svoje banke tijekom procesa.',
          "bank_select_desc5": 'Napominjemo da CYGNUS u nekim zemljama surađuje s drugim tvrtkama (agregatorima otvorenog bankarstva poput GoCardless), pa tijekom postupka davanja suglasnosti možete naići i na nazive tih tvrtki.',
          "bank_data_input_desc": "Kliknite na 'Dalje' i preusmjerit ćemo vas na web stranicu vaše banke. Otvorit će se novi prozor. Molimo slijedite tamošnje upute. NEMOJTE zatvoriti niti osvježiti ovaj prozor",
          "bank_waiting": "Čekanje rezultata",
          "bank_waiting_desc": "Molimo slijedite upute na web stranici vaše banke. NEMOJTE osvježavati ovaj prozor.",
          "bank_error": "Pogreška",
          "bank_error_desc": "Nažalost, došlo je do pogreške",
          "bank_success": "Uspjeh",
          "bank_success_desc": "Sve je u redu",
          "close_window": "Zatvori",
          "you_selected": "Odabrana banka",
          "full_name": "Puno pravno ime",
          "legal_name": "Pravno ime",
          "email": "E-mail adresa",
          "phone": "Broj telefona",
          "dob": "Datum rođenja",
          "address": "Adresa",
          "country_code_hu": "Mađarska",
          "client_type": "Tip klijenta",
          "client_type_personal": "Osobni račun",
          "client_type_business": "Poslovni račun",
          "all_rights": "Sva prava pridržana ⓒ 2025 - Cygnus AISP UAB",
          "terms_of_service": "Uvjeti korištenja",
          "impressum": "Impressum",
          "cookie_policy": "Politika kolačića",
          "not_available": "Trenutno nije dostupno",
          "bank_error_title": "Došlo je do pogreške",
          "bank_error": "Žao nam je, ali došlo je do pogreške tijekom procesa. Molimo kontaktirajte našu podršku.",
          "bank_success_title": "Uspjeh!",
          "bank_success": "Nemate drugih koraka za dovršiti.",
          "bank_success_next": "Nastavite na web stranicu pružatelja",
          "european_banking_authority": "Europska agencija za bankarstvo",
          "aisp_licence": "AISP registrirana licenca",
          "chosen_bank": "Odabrana banka",
          "cant_be_empty": "Ne može biti prazno",
          "must_be_long": "Ovo polje mora imati najmanje 8 znakova",
          "please_accept_terms": "Molimo prihvatite uvjete kako biste nastavili",
          "please_enter_data": "Unesite sljedeće podatke kako biste započeli proces",
          "bank_account_number": "Broj bankovnog računa",
          "bank_login_id": "ID za prijavu u banku",
          "bank_login_id_input": "Direktni ID",
          "bank_login_id_input_hr": "OIB broj",
          "bank_login_id_input_hr_otp": "mToken broj",
          "bank_login_id_desc": "Za autorizaciju vašeg pristanka trebat će Direktni ID koji ćete koristiti za prijavu u banku.",
          "bank_login_id_desc_hr": "Za autorizaciju vašeg pristanka trebat će vaš osobni OIB broj za banku.",
          "bank_login_id_desc_hr_otp": "Za autorizaciju vašeg pristanka trebat će vaš osobni mToken broj za banku.",
          "bank_account_number_part_1": "Dio 1",
          "do_credit_check": "Izradi izvještaj",
          "accept_terms_text": "<0>Pristajem da CYGNUS, kao obrađivač podataka i voditelj obrade, ima pristup mojim bankovnim podacima za razdoblje od 90 dana koje prethodi takvom pristanku isključivo u svrhu pružanja platnih usluga (test solventnosti). <3>Pravila o privatnosti</3></0>",
          "working": "Radimo...",
          "please_wait": "Molimo ne zatvarajte ovaj prozor dok se obrada ne završi.",
          "invalid_account_number": "Ovaj broj računa nije valjan. Molimo provjerite ponovno.",
          "account_number_required": "Broj računa je potreban za ovu banku",
          "account_number_not_numeric": "Broj računa mora sadržavati samo brojeve",
          "account_number_length": "Broj računa mora biti dug 16 ili 24 znaka",
          "account_number_format_cz": "Broj računa mora biti u ispravnom formatu",
          "account_number_format_hr": "Broj računa mora biti u ispravnom formatu (17 znamenki)",
          "bank_login_id_required": "ID za prijavu u banku je potreban za ovu banku",
          "bank_login_id_format_hu": "ID za prijavu u banku mora biti u ispravnom formatu (8 znamenki)",
          "bank_login_id_format_hr": "OIB broj mora biti u ispravnom formatu (11 znamenki)",
          "bank_login_id_format_hr_otp": "mToken broj mora biti u ispravnom formatu (10 znamenki)",
          "window_open_text": "Ako se novi prozor ne pojavi, molimo kliknite ovdje za nastavak:",
          "continue": "Nastavi",
          "bank_not_on_the_list": "Moja banka nije na popisu",
          "refuse_consent": "Ne želim dati pristanak",
          need_bank_account: 'Za nastavak ćeš trebati svoj IBAN broj računa. Ako znaš broj svog računa, ali ne znaš IBAN format',
          click_here: 'klikni ovdje',
          validate_iban_title: 'Provjera IBAN-a',
          validate_iban: 'Provjera IBAN-a',
          validate_iban_desc: 'Upišite ili zalijepite broj svog računa u domaćem formatu i prikazat ćemo vam vaš IBAN. Ako ga zalijepite, broj računa može sadržavati brojeve i crtice.',
          iban_account_number: 'Vaš IBAN broj računa:',
          close: 'Zatvori'
        }
      }
    }
  });

export default i18n;